{
    "locale": "ro-RO",
    "General": {
        "OrText": "Sau",
        "Title_MyHubert": "My Hubert",
        "Button_GoTo_MyHubert": "Mergi la My Hubert"
    },
    "Header": {
        "ButtonText_CreateNewAccount": "Creează cont nou",
        "ButtonText_SignInToYourAccount": "Conectează-te la contul tău",
        "ButtonText_StartInterviewWithoutSigningUp": "Începe interviul fără să te înregistrezi",
        "ButtonText_StartInterviewWithoutSigningIn": "Începe interviul fără să te conectezi",
        "Navlink_Dashboard": "Acasă",
        "Navlink_MyInterviews": "Interviurile mele",
        "Navlink_LearnWithHubert": "Învață cu Hubert",
        "Navlink_HelpCenter": "Centru de ajutor",
        "MyProfile": "Profilul meu",
        "LogOut": "Deconectare"
    },
    "Login": {
        "MainTitle": "Vezi rezultatele interviului tău cu Hubert",
        "Subtitle": "Conectează-te pentru a vedea rezultatele, a primi feedback, a citi sfaturi și multe altele.",
        "LoginTitle": "Conectează-te la contul tău Hubert",
        "Label_Email": "Email",
        "Label_Password": "Parolă",
        "ButtonText_SignIn": "Conectează-te",
        "ButtonText_ForgotPassword": "Ai uitat parola?",
        "ButtonText_ContinueWithGoogle": "Continuă cu Google",
        "OrSeparator": "Sau",
        "Error_Email_Required": "Emailul este obligatoriu.",
        "Error_Email_Invalid": "Introdu o adresă de email validă.",
        "Error_Password_Required": "Parola este obligatorie.",
        "Error_Use_Same_Email_As_Interview": "Folosește aceeași adresă de email pe care ai folosit-o pentru interviu."
    },
    "Registration": {
        "MainTitle": "Vezi rezultatele interviului tău cu Hubert",
        "Subtitle": "Creează un cont pentru a vedea rezultatele, a primi feedback, a citi sfaturi și multe altele.",
        "RegistrationTitle": "Creează un cont Hubert",
        "BenefitsBox_Title": "Poți să",
        "BenefitsBox_Point1": "accesezi istoricul interviurilor tale",
        "BenefitsBox_Point2": "primești feedback pentru interviurile tale",
        "BenefitsBox_Point3": "refolosești răspunsurile în interviuri noi",
        "BenefitsBox_Point4": "primești sfaturi pentru interviuri",
        "BenefitsBox_Point5": "citești ghiduri de carieră",
        "BenefitsBox_Point6": "și multe altele",
        "Label_FirstName": "Prenume",
        "Label_LastName": "Nume",
        "Label_Email": "Email",
        "Label_Password": "Parolă",
        "Label_PhoneNumber": "Număr de telefon",
        "Label_TermsOfService": "Accept",
        "Label_TermsOfServiceLink": "Politica de confidențialitate și Termenii și condițiile",
        "Placeholder_CountryCode": "Selectează prefixul de țară",
        "Placeholder_PhoneNumber": "Ex. 0712345678",
        "HelpText_Password": "Parola trebuie să aibă cel puțin 6 caractere.",
        "ButtonText_SignUp": "Înregistrează-te",
        "ButtonText_SignUpWithGoogle": "Înregistrează-te cu Google",
        "OrSeparator": "Sau",
        "Error_FirstName_Required": "Prenumele este obligatoriu.",
        "Error_LastName_Required": "Numele este obligatoriu.",
        "Error_Email_Required": "Emailul este obligatoriu.",
        "Error_Email_Invalid": "Introdu o adresă de email validă.",
        "Error_Email_Exists": "Această adresă de email este deja folosită.",
        "Error_Password_Required": "Parola este obligatorie.",
        "Error_Password_6_Characters": "Parola trebuie să aibă cel puțin 6 caractere.",
        "Error_PhoneNumber_Required": "Numărul de telefon este obligatoriu.",
        "Error_PhoneNumber_Invalid": "Numărul de telefon nu este valid.",
        "Error_PrivacyPolicyCheck_Required": "Trebuie să accepți Politica de confidențialitate și Termenii și condițiile."
    },
    "RegistrationInviteEmail": {
        "Subtitle_BeforeInterviewCompleted": "Pentru a susține interviul, acceptă Termenii și condițiile de utilizare a Hubert. Bifează căsuța pentru a continua.",
        "Subtitle_AfterInterviewCompleted": "Creează un cont pentru a vedea rezultatele, a primi feedback, a citi sfaturi și multe altele.",
        "PrivacyPolicyText": "Prin apăsarea butonului „Înregistrează-te”, accepți",
        "PrivacyPolicyLink": " Politica de confidențialitate și Termenii și condițiile",
        "ButtonText_SignUp": "Înregistrează-te și mergi la interviu",
        "ButtonText_SignUpNormal": "Înregistrează-te",
        "ButtonText_SignInInstead": "Apasă aici pentru a te conecta"
    },
    "LoginInviteEmail": {
        "Subtitle": "Conectează-te pentru a vedea rezultatele, a primi feedback, a citi sfaturi și multe altele."
    },
    "AppMessages": {
        "internal-server-error": "A apărut o eroare neașteptată.",
        "invalid-credentials": "Date de conectare incorecte. Încearcă din nou.",
        "user-not-found": "Date de conectare incorecte. Încearcă din nou.",
        "account-not-found": "Cont invalid. Încearcă din nou.",
        "verify-email-title": "Verifică-ți emailul",
        "verify-email-subtitle": "Verifică-ți emailul pentru a confirma contul.",
        "email-not-verified-title": "Email neverificat",
        "email-not-verified-subtitle": "Verifică-ți emailul pentru a confirma contul.",
        "verifying-email-title": "Se verifică emailul",
        "verifying-email-subtitle": "Te rugăm să aștepți...",
        "sign-in-title": "Conectare în curs",
        "sign-in-subtitle": "Te rugăm să aștepți...",
        "server-error": "Ceva nu a mers bine.",
        "hubert-user-exists": "Contul există deja.",
        "account-exists": "Contul există deja.",
        "email-verified": "Emailul tău a fost verificat.",
        "email-is-taken": "Această adresă de email este deja folosită.",
        "re-enter-password": "Folosește parola pentru a te conecta",
        "password-reset": "Parola ta a fost schimbată.",
        "re-enter-new-password": "Folosește noua parolă pentru a te conecta",
        "invalid-invitation": "Invitație invalidă.",
        "invalid-code": "Cod de verificare invalid.",
        "email-already-verified": "Emailul este deja verificat.",
        "email-mismatch-title": "Adresele de email nu se potrivesc",
        "email-mismatch-subtitle": "Folosește aceeași adresă de email pe care ai folosit-o când ai aplicat pentru acest post."
    },
    "TransitionPage": {
        "loading-title": "Se încarcă...",
        "loading-subtitle": "Îți pregătim datele...",
        "logout-title": "Se încarcă...",
        "logout-subtitle": "Te deconectăm..."
    },
    "ImpersonationPage": {
        "loading-title": "Se încarcă...",
        "loading-subtitle": "Îți pregătim datele..."
    },
    "ProcessInvitation": {
        "loading-title": "Se încarcă...",
        "loading-subtitle": "Te rugăm să aștepți cât timp încărcăm interviul.",
        "InvitationNotFound": "Nu putem găsi interviul tău.",
        "InvitationExpired": "Linkul de acces la interviu a expirat.",
        "InvitationExpired_Description1": "Deschide interviul din",
        "InvitationExpired_Description2": "sau contactează recrutorul.",
        "InvitationInvalid": "Linkul acestei invitații nu este valid.",
        "InterviewCompleted": "Acest interviu a fost deja finalizat."
    },
    "Common": {
        "MyInterviews": {
            "Title": "Interviurile mele",
            "TableHead_Employer": "Angajator",
            "TableHead_Job": "Post",
            "TableHead_Status": "Stare",
            "TableHead_ApplicationDate": "Data candidaturii",
            "TableBody_StartInterview": "Interviul nu este finalizat. Apasă aici pentru a începe sau a relua interviul.",
            "TableBody_NotScored": "Interviul este finalizat. Rezultatele vor fi disponibile în curând.",
            "TableBody_Details": "Apasă aici pentru a vedea rezultatele interviului și alte detalii.",
            "ApplicationDate_Invited": "Invitat",
            "ApplicationDate_MinuteAgo": "minut în urmă",
            "ApplicationDate_MinutesAgo": "minute în urmă",
            "ApplicationDate_HourAgo": "oră în urmă",
            "ApplicationDate_HoursAgo": "ore în urmă",
            "ApplicationDate_DayAgo": "zi în urmă",
            "ApplicationDate_DaysAgo": "zile în urmă",
            "ButtonText_SeeAllInterviews": "Vezi toate interviurile",
            "ButtonText_Details": "Detalii",
            "ButtonText_StartInterview": "Mergi la interviu",
            "ButtonText_NotScored": "Rezultate în așteptare",
            "NoInterviews_Message": "Nu există interviuri anterioare sau viitoare pentru tine."
        },
        "LatestJobPostings": {
            "NoJobPostings": "Momentan nu există oferte de job. Revino mai târziu."
        }
    },
    "Dashboard": {
        "MyCareer": {
            "Title": "Cariera mea",
            "Subtitle": "Selectează un interviu pentru a vedea evaluarea și oportunitățile tale.",
            "MostRecentInterview": "Cel mai recent interviu",
            "ToDo": "De făcut",
            "NoOngoingInterviews_Title": "Încă nu ai invitații noi la interviu.",
            "NoOngoingInterviews_Subtitle": "Noile interviuri Hubert vor apărea aici după ce sunt programate de recrutori.",
            "NoRecentInterviews_Title": "Nu am găsit interviuri anterioare.",
            "NoRecentInterviews_Subtitle": "Când vei primi o invitație la interviu, aceasta va apărea mai jos.",
            "ButtonText_StartInterview": "Mergi la interviu",
            "ButtonText_NotScored": "Rezultate în așteptare",
            "ButtonText_Details": "Detalii"
        },
        "LearnWithHubert": {
            "Title": "Învață cu Hubert",
            "Subtitle": "Primește sfaturi despre cum să îți îmbunătățești abilitățile de interviu și performanța la locul de muncă.",
            "PickedForMe": "Cele mai recente articole",
            "ButtonText_SeeAllArticles": "Vezi toate articolele"
        },
        "HubertTip": {
            "Title": "Sfat de la Hubert",
            "Subtitle": "Finalizează interviurile mai rapid",
            "Description": "Aplici pentru un job nou, într-un rol similar cu unul pentru care ai susținut deja un interviu Hubert? Poți refolosi răspunsurile din interviul anterior pentru a economisi timp.",
            "ButtonText_ReadMoreTips": "Citește mai multe sfaturi"
        },
        "NewCandidateModalPopup": {
            "Title": "Totul este gata!",
            "DescriptionLine1": "Contul tău este gata.",
            "DescriptionLine2": "Gestionează-ți interviurile și profilul. Vezi rezultatele, primește feedback și află cum să susții interviurile cât mai bine.",
            "ButtonText_LetsGo": "Începem"
        },
        "InterviewCompletedModal": {
            "Title": "Bravo!",
            "Subtitle": "Ai finalizat interviul.",
            "Description": "Echipa de recrutare va analiza toate candidaturile și îți va trimite un răspuns prin email sau telefon imediat ce există o actualizare.",
            "ButtonText_Continue": "Continuă"
        },
        "LatestJobPostings": {
            "Title": "Cele mai recente oferte de job",
            "Subtitle": "Descoperă alte oportunități publicate recent de partenerii Hubert."
        }
    },
    "MyInterviews": {
        "MyInterviewsSection_Title": "Interviurile mele",
        "MyInterviewsSection_Subtitle": "Selectează un interviu pentru a vedea evaluarea și oportunitățile tale de carieră.",
        "MyInterviewsSection_ToDo": "De făcut"
    },
    "Interview": {
        "ButtonText_SeeAllInterviews": "Vezi toate interviurile",
        "InterviewNotFound_Title": "Interviul nu este accesibil",
        "InterviewNotFound_Description": "Încerci să accesezi detalii despre un interviu care nu este asociat contului tău.",
        "ButtonText_GoToAllInterviews": "Mergi la Interviurile mele",
        "InterviewDetails": {
            "Title": "Detalii despre interviu",
            "ForRole": "Pentru rolul",
            "InterviewCompletedOn": "Interviu finalizat pe {{date}} la {{time}}"
        },
        "MyResult": {
            "Title": "Rezultatul meu",
            "Subtitle": "Grad de potrivire evaluat",
            "ButtonText_LearnMore": "Află cum sunt evaluate răspunsurile tale",
            "GotPotential_Title": "Potențial ridicat, dar lipsește o cerință",
            "GotPotential_Description": "Răspunsurile tale indică un potențial ridicat pentru acest tip de rol. Totuși, pe baza acestui interviu, este posibil să nu îndeplinești una sau mai multe calificări obligatorii pentru acest post. Acest lucru poate influența pașii următori, în funcție de nevoile recrutorului și de profilul celorlalți candidați. Dacă nu ești invitat la etapa următoare, te rugăm să reții că acest lucru nu spune totul despre potențialul tău ca candidat. De multe ori, este vorba pur și simplu despre potrivirea cât mai exactă cu nevoile specifice ale rolului. Vezi mai jos alte oportunități și sfaturi care te pot ajuta să îți îmbunătățești răspunsurile.",
            "GotPotential_DescriptionSecondary": "Evaluarea realizată de Hubert are caracter orientativ. Decizia finală îi aparține recrutorului, iar rezultatul poate fi influențat și de alți factori, cum ar fi numărul de candidați.",
            "GreatMatch_Title": "Potrivire foarte bună",
            "GreatMatch_Description": "Răspunsurile tale s-au aliniat bine cu ceea ce caută de obicei recrutorii pentru acest rol, iar tu îndeplinești cerințele postului. Foarte bine. Recrutorul va analiza toți candidații și va decide pașii următori.",
            "GreatMatch_DescriptionSecondary": "Evaluarea realizată de Hubert are caracter orientativ. Decizia finală îi aparține recrutorului, iar rezultatul poate fi influențat și de alți factori, cum ar fi numărul de candidați. Dacă nu ești invitat la etapa următoare, te rugăm să reții că acest lucru nu spune totul despre potențialul tău ca candidat. De multe ori, este vorba pur și simplu despre potrivirea cât mai exactă cu nevoile specifice ale rolului. Vezi mai jos alte oportunități și sfaturi care te pot ajuta să îți îmbunătățești răspunsurile.",
            "OkMatch_Title": "Calificat, cu loc de mai mult impact",
            "OkMatch_Description": "Îndeplinești cerințele postului. Pentru a ieși mai bine în evidență, răspunsurile tale ar putea beneficia de mai multă claritate și specificitate față de ceea ce văd de obicei recrutorii pentru acest rol. Revizuiește răspunsurile de mai jos ca să vezi unde un exemplu concret sau un rezultat clar îți poate îmbunătăți scorul.",
            "OkMatch_DescriptionSecondary": "Evaluarea realizată de Hubert are caracter orientativ. Decizia finală îi aparține recrutorului, iar rezultatul poate fi influențat și de alți factori, cum ar fi numărul de candidați.",
            "NotClearMatch_Title": "Poate că nu este încă rolul potrivit",
            "NotClearMatch_Description": "Pe baza acestui interviu, răspunsurile tale pot fi mai puțin aliniate cu ceea ce caută recrutorul pentru acest rol sau este posibil să nu îndeplinești una sau mai multe cerințe. Dacă vrei să îți îmbunătățești rezultatul, începe cu întrebările de mai jos. Schimbările mici, mai multe detalii concrete și rezultatele clare pot face o diferență mare data viitoare.",
            "NotClearMatch_DescriptionSecondary": "Evaluarea realizată de Hubert are caracter orientativ. Decizia finală îi aparține recrutorului, iar rezultatul poate fi influențat și de alți factori, cum ar fi numărul de candidați."
        },
        "ScoreBox": {
            "ProfessionalExperiences": "Experiență profesională, motivație și competențe",
            "QualifyingRequirements": "Cerințe obligatorii pentru acest post",
            "NotQualified_Title": "Este loc de îmbunătățire",
            "NotQualified_Description": "Este posibil ca răspunsurile tale să fi fost mai puțin specifice sau mai puțin orientate către rezultat decât se așteaptă recrutorul pentru acest rol. Vezi mai jos unde un exemplu concret, acțiuni specifice sau un rezultat clar îți pot întări răspunsul.",
            "GreatResults_Title": "Răspunsuri solide",
            "GreatResults_Description": "Răspunsurile tale arată că te potrivești bine acestui tip de rol și că ai comunicat clar. Dacă o întrebare poate fi îmbunătățită, o vei vedea evidențiată mai jos.",
            "MeetingRequirements_Title": "Cerințe îndeplinite",
            "MeetingRequirements_Description": "Răspunsurile tale indică faptul că îndeplinești cerințele obligatorii stabilite pentru acest post. Este o bază bună.",
            "NotAllExpectationsMet_Title": "Lipsesc una sau mai multe cerințe",
            "NotAllExpectationsMet_Description": "Pe baza răspunsurilor tale, este posibil să nu îndeplinești una sau mai multe cerințe obligatorii pentru acest post, cum ar fi certificate, autorizații, nivel de studii sau ani de experiență.",
            "ButtonText_FindOutPossibleReasons": "Vezi detalii"
        },
        "ScriptFromInterview": {
            "Title": "Citește interviul complet",
            "ButtonText_SeeWholeTranscript": "Citește interviul",
            "ButtonText_DeleteInterview": "Șterge interviul",
            "Loading_Title": "Se încarcă...",
            "Loading_Subtitle": "Te rugăm să aștepți cât timp încărcăm transcrierea interviului."
        },
        "HowToImproveAtInterviews": {
            "Title": "Cum să te descurci mai bine la interviuri",
            "Subtitle_Questions": "Iată câteva întrebări la care răspunsul tău ar putea fi îmbunătățit.",
            "Subtitle_NoQuestions": "Nu a fost marcat niciun răspuns specific. Iată cum îți poți face răspunsurile mai convingătoare pentru acest rol.",
            "GreatMatch_Questions_Description": "Chiar și atunci când potrivirea este foarte bună, unele răspunsuri pot fi întărite. Dacă am identificat astfel de răspunsuri, le vei găsi mai jos. Urmează instrucțiunile dinaintea fiecărei întrebări. Când descrii o situație, include contextul, ce ai făcut și rezultatul. Un răspuns de tip „OK” nu ajută atunci când ți se cere să detaliezi. În același timp, evită răspunsurile prea lungi. Încearcă să formulezi descrieri clare și concrete, ca într-un interviu față în față.",
            "GreatMatch_NoQuestions_Description": "Ai răspuns bine la întrebări. Foarte bine.",
            "OkMatch_Questions_Description": "Mai jos vei găsi întrebări la care răspunsul tău poate fi îmbunătățit. Urmează instrucțiunile dinaintea fiecărei întrebări. Când descrii o situație, include contextul, ce ai făcut și rezultatul. Un răspuns de tip „OK” nu ajută atunci când ți se cere să detaliezi. În același timp, evită răspunsurile prea lungi. Încearcă să formulezi descrieri clare și concrete, ca într-un interviu față în față.",
            "OkMatch_NoQuestions_Description": "Răspunsurile tale au fost solide, dar acest rol poate fi competitiv. Asta înseamnă că și răspunsurile bune pot ajunge în zona de mijloc a evaluării.",
            "OkMatch_NoQuestions_DescriptionSecondary": "Data viitoare, urmărește mai multă claritate și impact. Începe cu rezultatul, adaugă un exemplu real și păstrează răspunsul concis, de obicei 3–6 propoziții. Fii specific despre ce ai făcut, cum ai făcut și ce s-a schimbat datorită contribuției tale.",
            "GotPotential_Questions_Description": "Chiar dacă pari potrivit pentru acest tip de job, unele răspunsuri pot fi întărite. Dacă am identificat astfel de răspunsuri, le vei găsi mai jos. Urmează instrucțiunile dinaintea fiecărei întrebări. Când descrii o situație, include contextul, ce ai făcut și rezultatul. Un răspuns de tip „OK” nu ajută atunci când ți se cere să detaliezi. În același timp, evită răspunsurile prea lungi. Încearcă să formulezi descrieri clare și concrete, ca într-un interviu față în față.",
            "GotPotential_NoQuestions_Description": "Nu am identificat răspunsuri care au nevoie de îmbunătățiri importante în zona competențelor profesionale și a motivației. Pe aceste subiecte, pare că ai răspuns bine.",
            "NotClearMatch_Questions_Description": "Mai jos vei găsi întrebări la care răspunsul tău poate fi îmbunătățit. Urmează instrucțiunile dinaintea fiecărei întrebări. Când descrii o situație, include contextul, ce ai făcut și rezultatul. Un răspuns de tip „OK” nu ajută atunci când ți se cere să detaliezi. În același timp, evită răspunsurile prea lungi. Încearcă să formulezi descrieri clare și concrete, ca într-un interviu față în față.",
            "NotClearMatch_NoQuestions_Description": "Nu am găsit un singur răspuns „greșit”. Este mai degrabă vorba despre potrivirea generală cu ceea ce cere acest rol. Când concurența este mare, și diferențele mici pot conta.",
            "NotClearMatch_NoQuestions_DescriptionSecondary": "La următorul interviu, concentrează-te pe exemple concrete. Alege câte un exemplu pentru fiecare întrebare, explică ce ai făcut și spune care a fost rezultatul. Un răspuns scurt și specific este, de obicei, mai bun decât unul lung și general.",
            "Alert_WantMoreAdvice": "Vrei mai multe sfaturi despre cum să te descurci bine la un interviu Hubert?",
            "AlertLink_ExploreOurGeneralAdviceArticle": "Vezi articolul nostru cu sfaturi generale"
        },
        "SimilarOffers": {
            "Title": "Oferte similare"
        },
        "HowHubertScoresInterviews": {
            "Title": "Cum evaluează Hubert interviurile?",
            "Description": "Mai jos găsești o scurtă explicație despre cum evaluează Hubert răspunsurile la interviu. Am adăugat și o secțiune numită „Procesul de recrutare”, pentru a explica pașii următori după interviul Hubert.",
            "Tabs_PossibleOutcomes": "Rezultate posibile",
            "Tabs_RecruitmentProcess": "Procesul de recrutare",
            "AssessedMatch_Title": "Grad de potrivire evaluat",
            "AssessedMatch_Description": "Hubert evaluează impresia generală pe care o lasă răspunsurile tale, în comparație cu ceea ce caută de obicei recrutorii pentru acest rol. Împreună cu cerințele rolului, vei vedea unul dintre rezultatele de mai jos.",
            "AssessedMatch_DescriptionSecondary": "Evaluarea realizată de Hubert are caracter orientativ. Decizia finală îi aparține recrutorului, iar rezultatul poate fi influențat și de alți factori, cum ar fi numărul de candidați.",
            "GreatMatch_Title": "Potrivire foarte bună",
            "GreatMatch_Description": "Răspunsurile tale s-au aliniat bine cu ceea ce caută de obicei recrutorii pentru acest rol, iar tu îndeplinești cerințele postului. Foarte bine. Recrutorul va analiza toți candidații și va decide pașii următori.",
            "GotPotential_Title": "Potențial ridicat, dar lipsește o cerință",
            "GotPotential_Description": "Răspunsurile tale indică un potențial ridicat pentru acest tip de rol. Totuși, pe baza acestui interviu, este posibil să nu îndeplinești una sau mai multe calificări obligatorii pentru acest post. Acest lucru poate influența pașii următori, în funcție de nevoile recrutorului și de profilul celorlalți candidați.",
            "OkMatch_Title": "Calificat, cu loc de mai mult impact",
            "OkMatch_Description": "Îndeplinești cerințele postului. Pentru a ieși în evidență, răspunsurile tale ar putea avea nevoie de mai multă claritate și specificitate față de ceea ce văd de obicei recrutorii pentru acest rol. Folosește feedbackul din interviu pentru a-ți întări exemplele și rezultatele pe viitor.",
            "NotClearMatch_Title": "Poate că nu este încă rolul potrivit",
            "NotClearMatch_Description": "Pe baza acestui interviu, răspunsurile tale pot fi mai puțin aliniate cu ceea ce caută recrutorul pentru acest rol și este posibil să nu îndeplinești una sau mai multe cerințe. Revizuiește-ți răspunsurile pentru a vedea unde poți adăuga mai multă claritate, exemple concrete și rezultate.",
            "ProfessionalExperiences_Title": "Experiență profesională, motivație și competențe",
            "ProfessionalExperiences_Description": "Acestea sunt întrebări despre experiența ta anterioară, motivația pentru job și competențele relevante pentru rol. Recrutorii decid ce întrebări sunt folosite în interviul pentru fiecare post.",
            "GreatResults_Title": "Răspunsuri solide",
            "GreatResults_Description": "Răspunsurile tale arată că te potrivești bine acestui tip de rol și că ai comunicat clar. Dacă o întrebare poate fi îmbunătățită, o vei vedea evidențiată în interviul tău.",
            "NotQualified_Title": "Este loc de îmbunătățire",
            "NotQualified_Description": "Este posibil ca răspunsurile tale să fi fost mai puțin specifice sau mai puțin orientate către rezultat decât se așteaptă recrutorul pentru acest rol. Caută zonele evidențiate unde un exemplu concret, acțiunile tale sau un rezultat clar îți pot întări răspunsurile.",
            "QualifyingRequirements_Title": "Cerințe de bază sau obligatorii pentru acest post",
            "QualifyingRequirements_Description": "Acestea sunt întrebări pe care recrutorul le-a stabilit ca cerințe obligatorii pentru post. De exemplu, un certificat obligatoriu, permis de conducere sau un anumit nivel de experiență relevantă.",
            "MeetingRequirements_Title": "Cerințe îndeplinite",
            "MeetingRequirements_Description": "Răspunsurile tale indică faptul că îndeplinești cerințele obligatorii stabilite de recrutor pentru acest post. Este o bază bună.",
            "NotAllExpectationsMet_Title": "Lipsesc una sau mai multe cerințe",
            "NotAllExpectationsMet_Description": "Pe baza răspunsurilor tale, este posibil să nu îndeplinești una sau mai multe cerințe obligatorii pentru acest post, cum ar fi certificate, autorizații, nivel de studii sau ani de experiență.",
            "RecruitmentProcess_Title": "Procesul de recrutare",
            "RecruitmentProcess_Description": "Hubert este folosit de obicei ca prim pas într-un proces de recrutare cu mulți candidați. Le oferă tuturor posibilitatea de a susține un interviu și de a spune mai multe despre ei, în propriile cuvinte. Pentru că întrebările sunt aceleași pentru toți candidații care aplică la același job, procesul este mai consecvent. Hubert nu folosește informații precum vârsta, genul, etnia, religia sau aspectul fizic, ceea ce ajută la reducerea riscului de prejudecăți inconștiente.",
            "EventOne_Title": "Susții interviul cu Hubert",
            "EventOne_Description": "Susții interviul cu Hubert când și unde îți este cel mai convenabil. Nu există limită de timp, iar poți lua o pauză oricând și continua de unde ai rămas.",
            "EventTwo_Title": "Interviul tău este evaluat",
            "EventTwo_Description": "Hubert îți evaluează răspunsurile folosind tehnologie modernă. De îndată ce evaluarea este finalizată, rezultatele sunt vizibile pentru tine aici, în My Hubert, și pentru recrutor în sistemul său de gestionare a candidaturilor.",
            "EventThree_Title": "Recrutorul selectează candidații pentru pașii următori",
            "EventThree_Description": "În sistemul de gestionare a candidaturilor, recrutorii pot vedea când este disponibil un nou rezultat de interviu Hubert. Apoi pot analiza răspunsurile tale și evaluarea realizată de Hubert. Pe baza evaluării orientative realizate de Hubert și a propriei evaluări, recrutorii decid dacă vei fi invitat la etapa următoare. Aceasta poate fi un apel telefonic, un test sau un interviu final. În unele cazuri, recrutorii pot aștepta înainte de a decide pașii următori. Dacă alți candidați se potrivesc mai bine, candidatura ta poate fi respinsă.",
            "ButtonText_Close": "Închide"
        }
    },
    "MyProfile": {
        "Title": "Profilul meu",
        "MyDetails": {
            "Title": "Datele mele",
            "Label_FirstName": "Prenume",
            "Label_LastName": "Nume",
            "Label_Email": "Email",
            "Label_PhoneNumber": "Număr de telefon",
            "ButtonText_UpdateDetails": "Actualizează datele",
            "Error_FirstName_Required": "Prenumele este obligatoriu.",
            "Error_LastName_Required": "Numele este obligatoriu.",
            "Error_Email_Required": "Emailul este obligatoriu.",
            "Error_Email_Invalid": "Introdu o adresă de email validă.",
            "Error_PhoneNumber_Invalid": "Numărul de telefon nu este valid.",
            "Success_Details_Updated": "Profil actualizat."
        },
        "ChangePassword": {
            "Title": "Schimbă parola",
            "Set_Password_Title": "Creează parolă",
            "Label_CurrentPassword": "Parola actuală",
            "Label_NewPassword": "Parolă nouă",
            "Label_RepeatNewPassword": "Repetă parola nouă",
            "Alert_SignInAgain": "Conectează-te din nou pentru a-ți seta parola.",
            "ButtonText_UpdatePassword": "Actualizează parola",
            "ButtonText_SetPassword": "Setează parola",
            "ButtonText_SignInAgain": "Conectează-te din nou",
            "Error_CurrentPassword_Required": "Parola actuală este obligatorie.",
            "Error_CurrentPassword_DoesntMatch": "Parola nu se potrivește cu parola actuală.",
            "Error_NewPassword_Required": "Parola nouă este obligatorie.",
            "Error_NewPassword_6_Characters": "Parola nouă trebuie să aibă cel puțin 6 caractere.",
            "Error_RepeatNewPassword_Required": "Confirmarea parolei noi este obligatorie.",
            "Error_RepeatNewPassword_DoesntMatch": "Parola nu se potrivește cu parola nouă.",
            "Success_Password_Changed": "Parolă actualizată.",
            "Error_Invalid_CurrentPassword": "Parola actuală nu este validă."
        },
        "NotificationPreferences": {
            "Title": "Preferințe de notificare",
            "Label_ReceiveUpdatesToggle": "Vreau să primesc noutăți de la Hubert.",
            "Label_ReceiveUpdatesToggleHelpText": "Vei primi ghiduri de carieră, sfaturi pentru interviuri și altele."
        },
        "AccountRemoval": {
            "Title": "Ștergerea contului",
            "ButtonText_RemoveMyAccount": "Șterge contul meu"
        }
    },
    "PreInterviewPage": {
        "Title_Hello": "Bună",
        "Subtitle": "Ești pe cale să începi interviul pentru job.",
        "TipBox_Title": "Iată câteva sfaturi care te pot ajuta să te descurci cât mai bine.",
        "TipBox_Tip1": "Susține interviul într-un loc liniștit, unde te poți concentra și poți scrie confortabil.",
        "TipBox_Tip2": "Răspunde de pe un computer cu tastatură, cu excepția cazului în care ești obișnuit să scrii mult de pe mobil.",
        "TipBox_Tip3": "Fii cât mai specific și detaliat în răspunsuri. Hubert și recrutorii vor să te cunoască mai bine.",
        "TipBox_Tip4": "Ia-ți timpul de care ai nevoie. Nu există limită de timp.",
        "TipBox_Tip5": "Poți lua o pauză oricând și poți continua de unde ai rămas.",
        "TipBox_Tip6": "Fii tu însuți și tratează interviul Hubert cu aceeași seriozitate ca pe un interviu cu o persoană.",
        "CheckAdviceArticle_Text1": "Dacă vrei mai multe sfaturi despre cum să te descurci bine la interviu, citește acest",
        "CheckAdviceArticle_Text2": "articol",
        "CheckAdviceArticle_Text3": "cu recomandări utile.",
        "ReadyToGetStarted": "Ești gata să începi?",
        "ORSeparator_Text": "Sau",
        "ButtonText_StartInterviewNow": "Începe interviul acum",
        "ButtonText_SetReminder": "Nu sunt gata, setează-mi un reminder",
        "PrivacyPolicyText": "Prin apăsarea butonului „Începe interviul”, accepți",
        "PrivacyPolicyLink": " Politica de confidențialitate și Termenii și condițiile"
    },
    "InterviewCompletedPageInviteEmail": {
        "CompletedAlert_Title": "Bravo!",
        "CompletedAlert_Subtitle": "Ai finalizat interviul.",
        "CompletedAlert_Description": "Echipa de recrutare va analiza toate candidaturile și îți va trimite un răspuns prin email sau telefon imediat ce există o actualizare.",
        "InterviewNotCompleted": "Acest interviu nu este finalizat."
    },
    "HelpCenter": {
        "BannerSection": {
            "Title": "Centru de ajutor",
            "Subtitle": "Găsește răspunsuri la cele mai frecvente întrebări despre Hubert.",
            "Label_Search": "caută în întrebările frecvente",
            "ButtonText_Search": "Caută"
        },
        "FAQSection": {
            "Tabs_All": "Toate",
            "Tabs_AboutHubertInterview": "Despre interviul Hubert",
            "Tabs_TechnicalSupport": "Suport tehnic"
        },
        "StillHaveQuestion": {
            "Title": "Mai ai o întrebare?",
            "Description": "Te ajutăm cu drag.",
            "DropUsAEmail": "Scrie-ne la hubert@hubert.ai"
        },
        "Q&ATexts": {
            "AboutHubertInterview": [
                {
                    "q": "Pot susține interviul prin apel telefonic?",
                    "a": "Momentan, Hubert funcționează doar prin chat. Dacă ai o afecțiune medicală care te împiedică să susții interviul, te rugăm să contactezi direct compania angajatoare. Hubert este responsabil doar pentru interviul prin chat."
                },
                {
                    "q": "Pot susține interviul în altă limbă?",
                    "a": "Pentru unele interviuri, poți selecta limba la început. Dacă această opțiune nu este disponibilă, cel mai probabil înțelegerea limbii interviului este o cerință pentru post. Pentru alte întrebări, contactează compania care recrutează."
                },
                {
                    "q": "Voi fi dezavantajat dacă dau răspunsuri scurte?",
                    "a": "Nu, atât timp cât răspunzi relevant la întrebări. Nu există o lungime minimă pentru răspuns, dar detaliile ajută de multe ori."
                },
                {
                    "q": "Pot refolosi răspunsurile dintr-un alt interviu cu Hubert?",
                    "a": "Da, poți refolosi răspunsuri anterioare dacă te-ai conectat la My Hubert și aplici pentru un rol similar."
                },
                {
                    "q": "Va citi un om interviul meu?",
                    "a": "Da, le cerem clienților noștri să verifice manual interviurile."
                },
                {
                    "q": "Am susținut interviul. Ce urmează?",
                    "a": "După finalizarea interviului, rezultatele sunt trimise recrutorului în sistemul de gestionare a candidaturilor al companiei. Recrutorii pot analiza apoi răspunsurile tale și evaluarea realizată de Hubert. Pe baza evaluării orientative realizate de Hubert și a propriei evaluări, recrutorii decid dacă vei fi invitat la etapa următoare. Aceasta poate fi un apel telefonic, un test sau un interviu final."
                },
                {
                    "q": "Am o întrebare despre pașii următori ai procesului. Pe cine contactez?",
                    "a": "Te rugăm să contactezi compania la care ai aplicat pentru job."
                },
                {
                    "q": "Cum vă asigurați că nu apar prejudecăți în procesul de recrutare?",
                    "a": "Reducerea prejudecăților este foarte importantă pentru noi. Ca sistem, Hubert este mai consecvent în evaluare decât poate fi un om. Modelele noastre sunt antrenate cu ajutorul mai multor evaluatori experți, cu experiențe diverse. În plus, Hubert nu folosește informații precum genul, vârsta, etnia, religia sau aspectul fizic, care sunt surse comune de prejudecăți în interviurile tradiționale."
                },
                {
                    "q": "Pot fi intervievat de o persoană în loc de Hubert?",
                    "a": "Te rugăm să contactezi compania la care ai aplicat pentru acest post pentru a întreba despre această posibilitate."
                },
                {
                    "q": "Hubert este o persoană?",
                    "a": "Nu, Hubert este un sistem informatic pentru interviuri și analiză."
                },
                {
                    "q": "Pot modifica răspunsurile mai târziu?",
                    "a": "Nu. La fel ca într-un interviu real, nu poți reface răspunsurile după ce le-ai trimis."
                },
                {
                    "q": "Cum pot avea succes la interviul Hubert?",
                    "a": "Citește cu atenție întrebările înainte să răspunzi. Urmează instrucțiunile. Oferă exemple reale din experiența ta și fii sincer."
                },
                {
                    "q": "Am nevoie de un job. Pe cine contactez?",
                    "a": "Te rugăm să contactezi compania la care ai aplicat."
                },
                {
                    "q": "Am susținut interviul, dar nu am primit încă niciun răspuns. Ce ar trebui să fac?",
                    "a": "Recrutorii decid pașii următori pe baza evaluării realizate de Hubert și a propriei evaluări. Poate urma un apel telefonic, un test sau un interviu final. Dacă alți candidați se potrivesc mai bine, candidatura ta poate fi respinsă. Poți contacta recrutorul pentru a verifica statusul candidaturii tale."
                },
                {
                    "q": "Am multă experiență, dar nu am primit jobul. De ce?",
                    "a": "Concurența pentru joburi poate fi ridicată, cu mulți candidați calificați. Dacă candidatura ta a fost respinsă, poți contacta compania pentru a întreba motivul. Poți verifica și My Hubert pentru feedback pe baza răspunsurilor din interviu și pentru a vedea alte opțiuni de joburi."
                },
                {
                    "q": "Cât durează interviul?",
                    "a": "Depinde de numărul de întrebări setate de recrutor. De obicei durează între 10 și 25 de minute. Nu te grăbi. Poți lua o pauză și continua mai târziu dacă ai nevoie."
                },
                {
                    "q": "Unde pot citi despre cum sunt gestionate datele mele?",
                    "a": "https://www.hubert.ai/candidate-privacy-policy"
                }
            ],
            "TechnicalSupport": [
                {
                    "q": "De ce nu văd interviurile mele Hubert anterioare?",
                    "a": "Asigură-te că ai folosit aceeași adresă de email când ai aplicat pentru job și când te-ai conectat la My Hubert. Acest lucru se aplică și în cazul conectării cu Google: emailul Google trebuie să fie același cu emailul folosit pentru candidatură. Încearcă să creezi un cont cu adresa de email pe care ai folosit-o când ai aplicat pentru job."
                },
                {
                    "q": "De ce nu am primit emailul pentru interviu?",
                    "a": "Verifică folderul Spam. Poți adăuga și hubert@hubert.ai în lista de contacte. Alternativ, creează un cont My Hubert, folosind emailul din candidatură, pentru a găsi acolo linkul către interviu."
                },
                {
                    "q": "Nu găsesc linkul către interviu în email.",
                    "a": "Verifică folderul Spam. Alternativ, creează un cont My Hubert, folosind emailul din candidatură, și mergi la „Interviurile mele” pentru a găsi linkul."
                },
                {
                    "q": "Interviul funcționează pe dispozitive mobile?",
                    "a": "Da, funcționează. Totuși, dacă îți este mai ușor să scrii de pe computer, îți recomandăm să folosești unul."
                },
                {
                    "q": "Interviul nu funcționează. Ce ar trebui să fac?",
                    "a": "Ne pare rău să auzim asta. Scrie-ne la hubert@hubert.ai și te vom ajuta."
                },
                {
                    "q": "Vreau să îmi șterg întregul cont My Hubert. Ce ar trebui să fac?",
                    "a": "Trimite-ne un email la hubert@hubert.ai și te vom ajuta."
                },
                {
                    "q": "Interviul a fost întrerupt. Cum pot reveni?",
                    "a": "Apasă pe linkul din emailul de invitație pentru a reveni de unde ai rămas sau conectează-te la My Hubert și selectează interviul din „Interviurile mele”."
                }
            ]
        }
    },
    "LearnWithHubert": {
        "BannerSection": {
            "Title": "Învață cu Hubert",
            "Subtitle": "Află cum să îți crești șansele în procesul de recrutare și cum să ai rezultate mai bune la locul de muncă.",
            "Label_Search": "caută ghiduri pentru interviuri și carieră",
            "ButtonText_Search": "Caută"
        },
        "TabSelector": {
            "MyFeed": "Feedul meu",
            "InterviewGuides": "Ghiduri pentru interviuri",
            "CareerGuides": "Ghiduri de carieră"
        },
        "NewestOnTheFeed": "Cele mai noi din feed",
        "PickedForMe": "Cele mai recente articole",
        "InterviewGuides": "Ghiduri pentru interviuri",
        "CareerGuides": "Ghiduri de carieră"
    },
    "Article": {
        "ButtonText_BackToAllArticles": "Înapoi la toate articolele"
    },
    "ForgotPassword": {
        "ResetLinkAlert_Title": "Resetează parola",
        "ResetLinkAlert_Subtitle": "Apasă pe linkul de resetare a parolei trimis pe email pentru a seta o parolă nouă și a te conecta la cont.",
        "PasswordNotSetAlert_Message": "Parola nu este setată. Te rugăm să te conectezi folosind ",
        "ResetYourPassword": {
            "MainTitle": "Vezi rezultatele interviului tău cu Hubert",
            "Subtitle": "Conectează-te ca să vezi rezultatele, să primești feedback, să citești sfaturi și multe altele.",
            "FormSectionTitle": "Resetează parola",
            "Label_NewPassword": "Parolă nouă",
            "Label_ConfirmNewPassword": "Confirmă parola nouă",
            "Error_NewPassword_Required": "Introdu o parolă nouă.",
            "Error_Password_6_Characters": "Parola nouă trebuie să aibă cel puțin 6 caractere.",
            "Error_ConfirmNewPassword_Required": "Trebuie să confirmi parola nouă.",
            "Error_ConfirmNewPassword_NotMatch": "Parola nu se potrivește cu parola nouă.",
            "Error_MalformedResetUrl": "Cod de securitate invalid. Încearcă din nou.",
            "Error_ResetPasswordFailed": "Am întâmpinat o problemă la resetarea parolei. Încearcă din nou.",
            "Error_WeakPassword": "Parola trebuie să conțină cel puțin 6 caractere.",
            "Error_InvalidCode_Title": "Cererea de resetare a parolei a expirat sau nu este validă.",
            "Error_InvalidCode_Subtitle": "Încearcă să resetezi parola din nou.",
            "ButtonText_SetNewPassword": "Setează parola nouă și conectează-te",
            "ButtonText_RememberYourPassword": "Îți amintești parola?",
            "ButtonText_SignInInstead": "Conectează-te în schimb"
        }
    },
    "PageNotFound": {
        "Title": "Pagina nu a fost găsită",
        "Description": "Se pare că nu găsim pagina pe care o cauți.",
        "ButtonText_GoToDashboard": "Mergi la Acasă",
        "ButtonText_GoToLogin": "Mergi la conectare"
    },
    "OldInterviewRedirectionModal": {
        "DescriptionLine1": "Refolosirea răspunsurilor nu este încă disponibilă pentru acest interviu. Ne așteptăm ca această funcționalitate să fie disponibilă în curând, dar poți susține interviul acum.",
        "DescriptionLine2": "Continuă către interviu apăsând butonul de mai jos.",
        "ButtonText_TakeMeToTheInterview": "Du-mă la interviu"
    },
    "UnsubscribeFromEmails": {
        "Title": "Ești sigur?",
        "Subtitle": "Nu vei mai primi emailuri de la noi despre acest job:",
        "SelectTheReason": "Selectează un motiv dintre opțiunile de mai jos.",
        "ReasonText1": "Mi-am găsit alt job.",
        "ReasonText2": "Nu mă mai interesează acest job.",
        "ReasonText3": "Alt motiv",
        "ButtonText_Unsubscribe": "Dezabonează-mă de la acest job",
        "Placeholder_YourReason": "Motivul tău",
        "Success_Title": "Te-ai dezabonat cu succes de la emailurile despre acest job.",
        "Loading": "Se încarcă...",
        "Error_YourReason_Required": "Introdu un motiv.",
        "Error_ServerIssue": "Dezabonarea a eșuat din cauza unei erori de server."
    },
    "SocialLoginCallback": {
        "ButtonText_TryAgain": "Încearcă din nou"
    },
    "Outreach": {
        "CandidateNotFound": "Candidatul nu a fost găsit",
        "CandidateNotFoundDesc": "Nu am putut găsi detaliile interviului pe care îl cauți.",
        "InterviewEnded": "Interviu încheiat",
        "InterviewEndedDesc1": "Această sesiune de interviu s-a încheiat sau nu mai este disponibilă.",
        "InterviewEndedDesc2": "Îți mulțumim pentru timpul acordat. Dacă ai întrebări, contactează echipa de recrutare.",
        "ReadyTitle": "Ești gata pentru interviu, {{firstName}}?",
        "InvitationDesc": "Hubert, în numele {{companyName}}, te invită la un interviu prin chat. Durează aproximativ 1–2 minute.",
        "Button_StartChat": "Începe interviul prin chat",
        "CancelNotice": "Dacă începi aici, apelul programat pentru acest rol va fi anulat.",
        "PreferNotToContinue": "Nu vrei să continui?",
        "DeclineLabel": "Nu mă interesează acest rol. Vă rog să nu mă mai sunați și să nu îmi mai trimiteți mesaje despre această poziție.",
        "Button_ConfirmAndDecline": "Confirmă și refuză",
        "Processing": "Se procesează...",
        "Toast_DeclineSuccess": "Interviu refuzat.",
        "Toast_CancelVoiceInfo": "Apel anulat. Funcționalitate disponibilă în curând.",
        "Toast_CancelError": "Nu am putut anula interviul. Încearcă din nou.",
        "Footer_WithdrawConsent": "Îți poți retrage consimțământul oricând. Află mai multe în Politica de confidențialitate a ",
        "Footer_PrivacyPolicySuffix": "",
        "Footer_And": " și în ",
        "Footer_HubertPrivacyLink": "Politica de confidențialitate și Termenii și condițiile Hubert",
        "Chat_InterviewWith": "Interviu cu {{companyName}}",
        "Chat_StatusConnected": "Conectat",
        "Chat_StatusError": "Eroare",
        "Chat_StatusDisconnected": "Deconectat",
        "Chat_StatusConnecting": "Se conectează...",
        "Chat_ReadyToStart": "Ești gata să începi interviul?",
        "Chat_ButtonStart": "Începe interviul",
        "Chat_SayHello": "Scrie „bună” ca să începi conversația.",
        "Chat_EmptyState": "Trimite un mesaj ca să începi interviul.",
        "Chat_SelectLanguage": "Alege limba preferată",
        "Chat_Placeholder": "Scrie mesajul tău...",
        "Chat_ButtonSend": "Trimite",
        "Chat_ButtonBack": "Înapoi",
        "LoadingCandidateDetails": "Se încarcă detaliile candidatului...",
        "FetchingCandidateDetails": "Se preiau detaliile candidatului...",
        "Chat_StatusReady": "Se așteaptă conectarea...",
        "Chat_ForbiddenError": "Acest interviu prin chat nu mai este disponibil.",
        "Chat_GeneralError": "Nu am putut porni chatul. Încearcă din nou mai târziu.",
        "Chat_SelectUiLanguage": "Limba interfeței",
        "Chat_InterviewTitle": "Interviu pentru job"
    }
}
